export default "__VITE_ASSET__CqFKeYB$__"